export default "__VITE_ASSET__89d9a903__"